import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'Quais são os principais serviços oferecidos pela Desentupidora da Cidade Nº1?',
      answer:
        'A Desentupidora da Cidade Nº1 oferece uma ampla gama de serviços, incluindo desentupimento de pias, ralos, vasos sanitários, redes de esgoto, além de limpeza de fossas e manutenção preventiva.',
    },
    {
      question: 'Como posso saber se preciso chamar uma desentupidora?',
      answer:
        'Você deve chamar uma desentupidora quando notar água parada em pias ou ralos, mau cheiro vindo dos canos, vasos sanitários que não descem completamente, ou qualquer sinal de entupimento nas tubulações.',
    },
    {
      question:
        'A Desentupidora da Cidade Nº1 atende apenas residências ou também estabelecimentos comerciais?',
      answer:
        'Atendemos tanto residências quanto estabelecimentos comerciais e industriais em toda região de Campinas, com equipe especializada para cada tipo de demanda.',
    },
    {
      question: 'Qual é o tempo médio de resposta para atendimento de emergência?',
      answer:
        'Nossa equipe chega em até 30 minutos na sua região em casos de emergência. Atendemos 24 horas por dia, todos os dias da semana, inclusive finais de semana e feriados.',
    },
    {
      question: 'Quais são os métodos utilizados pela Desentupidora da Cidade Nº1 para desentupimento?',
      answer:
        'Utilizamos equipamentos modernos como hidrojateamento de alta pressão, vídeo-inspeção, máquinas rotativas e técnicas especializadas que garantem desentupimento eficaz sem danificar as tubulações.',
    },
    {
      question: 'Os serviços da Desentupidora da Cidade Nº1 são seguros?',
      answer:
        'Sim, todos os nossos serviços seguem rigorosamente as normas de segurança. Nossos técnicos são certificados e utilizam EPIs adequados conforme legislação vigente.',
    },
    {
      question: 'Como posso evitar entupimentos frequentes em minha residência?',
      answer:
        'Evite jogar gordura, restos de comida e objetos nos ralos. Faça manutenção preventiva periódica, use ralos com proteção e contrate limpeza regular de caixas de gordura e fossas.',
    },
    {
      question: 'A Desentupidora da Cidade Nº1 oferece garantia para os serviços realizados?',
      answer:
        'Sim, oferecemos garantia de 3 meses para todos os nossos serviços. Se o problema voltar neste período, retornamos gratuitamente para resolver.',
    },
    {
      question: 'Como posso solicitar um orçamento para serviços de desentupimento?',
      answer:
        'Você pode solicitar orçamento gratuito pelo WhatsApp (19) 99999-9999, por telefone ou preenchendo o formulário em nosso site. A visita técnica também é gratuita.',
    },
    {
      question: 'A Desentupidora da Cidade Nº1 segue normas ambientais durante seus serviços?',
      answer:
        'Sim, seguimos rigorosamente todas as normas ambientais. Fazemos descarte ecológico de resíduos conforme legislação e utilizamos métodos que não agridem o meio ambiente.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Perguntas Frequentes sobre Desentupidora
          </h2>
          <p className="text-xl text-gray-600">Tire suas dúvidas sobre nossos serviços de desentupimento</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto mt-4"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <h4 className="text-lg font-semibold text-gray-800 pr-4">{faq.question}</h4>
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                    <i
                      className={`${
                        openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                      } text-blue-500 text-xl transition-transform`}
                    ></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <div className="border-t border-gray-100 pt-4">
                      <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-2xl p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Não encontrou sua dúvida?</h3>
            <p className="text-gray-600 mb-6">
              Entre em contato conosco pelo WhatsApp e tire todas suas dúvidas com nossa equipe
              especializada.
            </p>
            <button
              onClick={() => window.open('https://wa.me/5519981868997', '_blank')}
              className="w-full bg-green-500 hover:bg-green-600 text-white py-4 px-6 rounded-lg font-bold text-lg transition-all transform hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              <span>Fale Conosco pelo WhatsApp</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;